module.exports = __webpack_public_path__ + "static/media/store_outlet_shop_Selected.80faf442.svg";